/**
 * Generated by orval 🍺
 * Do not edit manually.
 * STBportalen
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  STBUser,
  STBUserDummyDto,
  UpdateSTBUserDto
} from '../../model';

import { customInstance } from '../../../mutator/custom-instance';
import type { ErrorType , BodyType } from '../../../mutator/custom-instance';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const postApiStbusers = (
    sTBUserDummyDto?: BodyType<STBUserDummyDto>,
 signal?: AbortSignal
) => {


      return customInstance<boolean>(
      {url: `/api/stbusers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sTBUserDummyDto, signal
    },
      );
    }




export const getPostApiStbusersMutationKey = () => ['postApiStbusers'] as const;

export const getPostApiStbusersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStbusers>>, TError,PostApiStbusersMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiStbusers>>, TError,PostApiStbusersMutationVariables, TContext> => {

const mutationKey = getPostApiStbusersMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStbusers>>, PostApiStbusersMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postApiStbusers(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiStbusersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStbusers>>>
    export type PostApiStbusersMutationBody = BodyType<STBUserDummyDto> | undefined
    export type PostApiStbusersMutationError = ErrorType<unknown>
    export type PostApiStbusersMutationVariables = {data?: BodyType<STBUserDummyDto>}

    export const usePostApiStbusers = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStbusers>>, TError,PostApiStbusersMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiStbusers>>,
        TError,
        PostApiStbusersMutationVariables,
        TContext
      > => {
      return useMutation(getPostApiStbusersMutationOptions(options), queryClient);
    }
    export const getApiStbusers = (

 signal?: AbortSignal
) => {


      return customInstance<STBUser[]>(
      {url: `/api/stbusers`, method: 'GET', signal
    },
      );
    }




export const getGetApiStbusersQueryKey = () => {
    return [
    `/api/stbusers`
    ] as const;
    }


export const getGetApiStbusersQueryOptions = <TData = Awaited<ReturnType<typeof getApiStbusers>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStbusers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStbusersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStbusers>>> = ({ signal }) => getApiStbusers(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStbusers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiStbusersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStbusers>>>
export type GetApiStbusersQueryError = ErrorType<unknown>


export function useGetApiStbusers<TData = Awaited<ReturnType<typeof getApiStbusers>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStbusers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStbusers>>,
          TError,
          Awaited<ReturnType<typeof getApiStbusers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiStbusers<TData = Awaited<ReturnType<typeof getApiStbusers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStbusers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStbusers>>,
          TError,
          Awaited<ReturnType<typeof getApiStbusers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiStbusers<TData = Awaited<ReturnType<typeof getApiStbusers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStbusers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiStbusers<TData = Awaited<ReturnType<typeof getApiStbusers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStbusers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiStbusersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiStbusers = (
    updateSTBUserDto?: BodyType<UpdateSTBUserDto>,
 signal?: AbortSignal
) => {


      return customInstance<boolean>(
      {url: `/api/stbusers`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateSTBUserDto, signal
    },
      );
    }




export const getPutApiStbusersMutationKey = () => ['putApiStbusers'] as const;

export const getPutApiStbusersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiStbusers>>, TError,PutApiStbusersMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiStbusers>>, TError,PutApiStbusersMutationVariables, TContext> => {

const mutationKey = getPutApiStbusersMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiStbusers>>, PutApiStbusersMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putApiStbusers(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiStbusersMutationResult = NonNullable<Awaited<ReturnType<typeof putApiStbusers>>>
    export type PutApiStbusersMutationBody = BodyType<UpdateSTBUserDto> | undefined
    export type PutApiStbusersMutationError = ErrorType<unknown>
    export type PutApiStbusersMutationVariables = {data?: BodyType<UpdateSTBUserDto>}

    export const usePutApiStbusers = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiStbusers>>, TError,PutApiStbusersMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiStbusers>>,
        TError,
        PutApiStbusersMutationVariables,
        TContext
      > => {
      return useMutation(getPutApiStbusersMutationOptions(options), queryClient);
    }
    export const getApiStbusersGetTeamleaders = (

 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/stbusers/GetTeamleaders`, method: 'GET', signal
    },
      );
    }




export const getGetApiStbusersGetTeamleadersQueryKey = () => {
    return [
    `/api/stbusers/GetTeamleaders`
    ] as const;
    }


export const getGetApiStbusersGetTeamleadersQueryOptions = <TData = Awaited<ReturnType<typeof getApiStbusersGetTeamleaders>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStbusersGetTeamleaders>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStbusersGetTeamleadersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStbusersGetTeamleaders>>> = ({ signal }) => getApiStbusersGetTeamleaders(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStbusersGetTeamleaders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiStbusersGetTeamleadersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStbusersGetTeamleaders>>>
export type GetApiStbusersGetTeamleadersQueryError = ErrorType<unknown>


export function useGetApiStbusersGetTeamleaders<TData = Awaited<ReturnType<typeof getApiStbusersGetTeamleaders>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStbusersGetTeamleaders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStbusersGetTeamleaders>>,
          TError,
          Awaited<ReturnType<typeof getApiStbusersGetTeamleaders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiStbusersGetTeamleaders<TData = Awaited<ReturnType<typeof getApiStbusersGetTeamleaders>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStbusersGetTeamleaders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiStbusersGetTeamleaders>>,
          TError,
          Awaited<ReturnType<typeof getApiStbusersGetTeamleaders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiStbusersGetTeamleaders<TData = Awaited<ReturnType<typeof getApiStbusersGetTeamleaders>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStbusersGetTeamleaders>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiStbusersGetTeamleaders<TData = Awaited<ReturnType<typeof getApiStbusersGetTeamleaders>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiStbusersGetTeamleaders>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiStbusersGetTeamleadersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






